<script setup lang="ts">
  import { useMutationObserver, useResizeObserver } from '@vueuse/core'
  import { onMounted, ref, useTemplateRef } from 'vue'

  const props = defineProps<{
    lineClamp?: 1 | 2 | 3,
  }>()

  const containerRef = useTemplateRef('containerRef')
  const clamped = ref(true)
  const isOverflowing = ref(false)

  const checkOverflow = () => {
    if (containerRef.value && clamped.value) {
      isOverflowing.value = containerRef.value.scrollHeight > containerRef.value.clientHeight
    }
  }

  onMounted(checkOverflow)

  useResizeObserver(containerRef, checkOverflow)

  useMutationObserver(containerRef, checkOverflow, { childList: true, subtree: true, characterData: true })

  const unclamp = () => {
    clamped.value = false
  }
  const reclamp = () => {
    clamped.value = true
  }
</script>

<template>
  <div
    ref="containerRef"
    :title="clamped && isOverflowing ? 'Klik untuk melihat lebih lengkap' : undefined"
    :class="{
      'line-clamp-1': clamped && (props.lineClamp === 1 || !props.lineClamp),
      'line-clamp-2': clamped && props.lineClamp === 2,
      'line-clamp-3': clamped && props.lineClamp === 3,
    }">
    <a
      class="whitespace-pre-line"
      :class="{'clampable-text mr-2' : isOverflowing}"
      @click.prevent="isOverflowing && unclamp()">
      <slot></slot>
    </a>
    <app-button
      title="Klik untuk menutup"
      class="btn-reclamp align-middle"
      @click="reclamp()">
      <fa-icon icon="i-far-square-chevron-up" />
    </app-button>
  </div>
</template>

<style scoped>
  .line-clamp-1,
  .line-clamp-2,
  .line-clamp-3 {
    .clampable-text {
      cursor: pointer;
    }
    .btn-reclamp {
      display: none;
    }
  }
</style>
